module.exports = __webpack_public_path__ + "img/background-blue.72b26bf.jpg";